// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZFDq","buttons":"styles_buttons__M-deW"};